module.exports = __webpack_public_path__ + "7690b7864b075e4e3bb5275f9ac880ae.png";